export default __webpack_public_path__ + "static/media/usa.96abee7e.svg";